
import Form from "./Form.vue";
import { mapActions } from "vuex";

export default {
  name: "app-listaPreco-update",
  data() {
    return {
      lista: {},
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getLista(id_lista_preco) {
      try {
        const response = await this.$http.post("/produtos/get-lista-preco", {
          id_lista_preco,
        });

        const data = response.data;

        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const id_lista_preco = this.$route.params.id_lista_preco;

        this.setLoading(true);

        const lista = await this.getLista(id_lista_preco);

        if (!lista.id_lista_preco || lista == null) {
          this.$router.push({ name: "listaPreco" });
          return this.$toast.error("Lista não encontrada!");
        }

        this.lista = lista;
        this.setLoading(false);
      } catch {
        return;
      }
    },
  },
  computed: {},
  mounted() {
    this.getInit();
  },
};
